import Vue from 'vue'
import Router from 'vue-router'
import IndexShip from '@/components/index/ship'
import IndexLogin from '@/components/index/login'
import IndexRegist from '@/components/index/regist'
import IndexIndex from '@/components/index/index'
import IndexNews from '@/components/index/news'
import IndexIncident from  '@/components/index/incident'
import UserDetail from '@/components/user/detail'
import UserPassword from '@/components/user/password'
import InquiryIndex from '@/components/inquiry/index'
import InquiryTerm from '@/components/inquiry/term'
import InquiryAdd from '@/components/inquiry/add'
import InquiryReview from '@/components/inquiry/review'
import ReportIndex from '@/components/report/index'
import ReportReview from '@/components/report/review'
import ReportAdd from '@/components/report/add'
import QuoteIndex from '@/components/quote/index'
import QuoteReview from '@/components/quote/review'
import NotFound from '@/components/index/notfound'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'IndexIndex',
      component: IndexIndex,
      meta: {
        title:'首页',
        navShow:false,
        index:1
      }
    },
    {
      path: '/index/login',
      name: 'IndexLogin',
      component: IndexLogin,
      meta: {
        title:'用户登录',
        navShow:false,
        index:5
      }
    },
    {
      path: '/index/regist',
      name: 'IndexRegist',
      component: IndexRegist,
      meta: {
        title:'用户注册',
        navShow:false,
        index:6
      }
    },
    {
      path: '/index/ship',
      name: 'IndexShip',
      component: IndexShip,
      meta: {
        title:'船舶查询',
        navShow:true,
        navPath:'/',
        index:0
      }
    },
    {
      path: '/user/detail',
      name: 'UserDetail',
      component: UserDetail,
      meta: {
        title:'我的信息',
        navShow:true,
        navPath:'/user/password',
        index:101
      }
    },
    {
      path: '/user/password',
      name: 'UserPassword',
      component: UserPassword,
      meta: {
        title:'修改密码',
        navShow:true,
        navPath:'/',
        index:37
      }
    },
    {
      path: '/index/news',
      name: 'IndexNews',
      component: IndexNews,
      meta: {
        title:'航运新闻',
        navShow:true,
        navPath:'/',
        index:18
      }
    },
    {
      path: '/index/incident',
      name: 'IndexIncident',
      component: IndexIncident,
      meta: {
        title:'海事通告',
        navShow:true,
        navPath:'/',
        index:17
      }
    },
    {
      path: '/report/index',
      name: 'ReportIndex',
      component: ReportIndex,
      meta: {
        title:'报案登记',
        navShow:true,
        navPath:'/',
        index:201
      }
    },
    {
      path: '/report/review',
      name: 'ReportReview',
      component: ReportReview,
      meta: {
        title:'报案记录',
        navShow:true,
        navPath:'/report/index',
        index:202
      }
    },
    {
      path: '/report/add',
      name: 'ReportAdd',
      component: ReportAdd,
      meta: {
        title:'报案登记',
        navShow:true,
        navPath:'/report/index',
        index:203
      }
    },
    {
      path: '/inquiry/index',
      name: 'InquiryIndex',
      component: InquiryIndex,
      meta: {
        title:'保险询价',
        navShow:true,
        navPath:'/',
        index:301
      }
    },
    {
      path: '/inquiry/term',
      name: 'InquiryTerm',
      component: InquiryTerm,
      meta: {
        title:'保险产品',
        navShow:true,
        navPath:'/',
        index:302
      }
    },
    {
      path: '/inquiry/add',
      name: 'InquiryAdd',
      component: InquiryAdd,
      meta: {
        title:'提交询报价',
        navShow:true,
        index:303
      }
    },
    {
      path: '/inquiry/review',
      name: 'InquiryReview',
      component: InquiryReview,
      meta: {
        title:'查看询报价',
        navShow:true,
        navPath:'/inquiry/index',
        index:304
      }
    },
    {
      path: '/quote/index',
      name: 'QuoteIndex',
      component: QuoteIndex,
      meta: {
        title:'询报价列表',
        navShow:true,
        navPath:'/',
        index:401
      }
    },
    {
      path: '/quote/review',
      name: 'QuoteReview',
      component: QuoteReview,
      meta: {
        title:'处理询报价',
        navShow:true,
        navPath:'/quote/index',
        index:402
      }
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        title:'Not Found',
        navShow:false,
        index:999
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js